import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_spec-evaluator/artifacts/8a4vgz8k_litvill_logo_alpha.png" 
            alt="Litvill Logo" 
            className="logo-image"
          />
        </Link>
        
        <button 
          className="nav-toggle" 
          onClick={() => setIsOpen(!isOpen)}
          data-testid="mobile-menu-toggle"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <Link 
              to="/" 
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
              data-testid="nav-home"
            >
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/english" 
              className={`nav-link ${isActive('/english') ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
              data-testid="nav-english"
            >
              English
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/programs" 
              className={`nav-link ${isActive('/programs') ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
              data-testid="nav-programs"
            >
              Programs
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/movement" 
              className={`nav-link ${isActive('/movement') ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
              data-testid="nav-movement"
            >
              Movement
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/about" 
              className={`nav-link ${isActive('/about') ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
              data-testid="nav-about"
            >
              About
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/contact" 
              className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
              data-testid="nav-contact"
            >
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;